// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Serbia from '../_raw/flag/icon_flag_serbia.png';

export default () => <img src={Serbia} alt="Serbia" />;
